import { useQuery } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { queriesEnabledAtom, tenantIDAtom } from "../../../atoms/GlobalAtoms";
import TenantAPI from "../../api/TenantAPI";
import { FormBuilder } from "../../../types/FormBuilderInterfaces";

const emptyArray: [] = [];

const usePublicForms = () => {
  const queriesEnabled = useAtomValue(queriesEnabledAtom);
  const tenantID = useAtomValue(tenantIDAtom);

  const publicForms = useQuery({
    queryKey: ["publicForms", tenantID],
    queryFn: () =>
      TenantAPI.getPublicForms().then((data) => {
        const publicForms: FormBuilder[] = data.data.data.publicForms;
        return publicForms;
      }),
    enabled: queriesEnabled,
    staleTime: Infinity,
  });

  const data: { publicForms: FormBuilder[]; publicFormsLoading: boolean } = {
    publicForms: (publicForms.data as FormBuilder[]) || emptyArray,
    publicFormsLoading: publicForms.isLoading,
  };

  return data;
};

export default usePublicForms;
